import { render } from "./index.vue?vue&type=template&id=9c212b36&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=9c212b36&scoped=true&lang=scss"
import "./index.vue?vue&type=style&index=1&id=9c212b36&lang=scss"

import exportComponent from "E:\\exercise\\skyMap\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c212b36"]])

export default __exports__